import React, {useEffect, useState} from 'react';
import {MallsData} from "../../Malls/MallsServices";
import {getMallWithSubDomain} from "../../../Services";
import {useHistory} from "react-router";

function FooterDesktop() {

    const [data, set_data] = useState([])
    const [mall, set_mall] = useState(null)
    const history = useHistory()


    // const convertDescHtml = ()=>{
    //     let toz = '\n\t\t\t\t<div class="wd-accordion-title wd-opener-pos-right woodmart-accordion-title tab-title-description wd-active" data-accordion-index="description">\n\t\t\t\t\t<div class="wd-accordion-title-text">\n\t\t\t\t\t\t<span>\n\t\t\t\t\t\t\tتوضیحات\t\t\t\t\t\t</span>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<span class="wd-accordion-opener wd-opener-style-arrow"></span>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="entry-content woocommerce-Tabs-panel woocommerce-Tabs-panel--description wd-active panel wc-tab" id="tab-description" role="tabpanel" aria-labelledby="tab-title-description" data-accordion-index="description" style="display: block;">\n\t\t\t\t\t<div class="wc-tab-inner">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\n\n<h2 style="text-align: justify">نقد و بررسی پودر گینر افتر شاک کریتیکال مس مایوژنیکس</h2>\n<p style="text-align: justify">پودر گینر افتر شاک کریتیکال مس مایوژنیکس یکی از بهترین گینرهای موجود در بازار هم از نظر افزایش وزن و هم افزایش حجم عضلات بدن است. بسیاری از افرادی که خواهان وزن و ماهیچه بیشتری هستند، علاوه بر داشتن تمرین قدرتی، باید استراحت و تغذیه کافی داشته باشند تا پیشرفت مناسبی را تجربه کنند. بنابراین باید حجم زیادی غذای پروتئینی مصرف کنند، ۶ تا ۸ ساعت استراحت داشته باشند و دائما ریز مغذی‌های مناسبی به بدن خود برسانند. این کار علاوه بر داشتن برنامه ریزی منظم و عمل به آن، مستلزم هزینه بسیار است که شاید بسیاری از جنبه‌های زندگی یک ورزشکار را تحت تاثیر قرار دهد.</p>\n<p style="text-align: justify">برای کاهش این هزینه‌ها و به دست آوردن تمام اهداف ورزشی ذکر شده، می‌توان از مکمل گینر After Shock استفاده کرد. همانطور که از اسمش پیداست، به بدن شما شوک قدرتمندی وارد نموده و به سرعت شما را عضلانی و حجیم می‌کند. شایان ذکر است شما برای <a href="https://mosbatesabz.com/product-category/bodybuilding-supplements/weight-gain-supplements/gainer/" target="_blank" rel="noopener">خرید مکمل گینر</a> می‌توانید به سایت مثبت سبز مراجعه کنید و از تخفیفات شگفت انگیز بهره مند شوید.</p>\n<h2 style="text-align: justify">بهترین گینر چه خصوصیاتی دارد ؟</h2>\n<p style="text-align: justify">اکثر گینرهای موجود در بازار کربوهیدرات و پروتئین دارند که نسبت کربوهیدرات به پروتئین ۳ به ۱ است. اما گینر مایوژنیکس علاوه بر داشتن کربوهیدرات و پروتئین با نسبت تقریبی ۲ به ۱، دارای گلوتامین و کراتین است؛ در هر اسکوپ حدود ۸۵ گرم کربوهیدرات و ۵۲ گرم پروتئین وجود دارد؛ این بدان معناست که با مصرف این گینر چاق نمی‌شوید و عضله سازی بسیار خوبی خواهید داشت. گلوتامین هم به شما کمک می‌کند تا علاوه بر عضله سازی بهتر، عملکرد سیستم ایمنی‌تان را بالاتر ببرید. کراتین هم به شما کمک می‌کند تا هم قدرت عضلاتتان افزایش محسوسی داشته باشد و هم استقامت بدنی شما در تمرینات هوازی بالاتر برود. خوشبختانه این محصول لاکتوز و چربی ترانس ندارد و با خیال راحت می‌توانید آن را مصرف کنید.</p>\n<hr>\n<h2 style="text-align: justify">ویژگی های پودر گینر افتر شاک کریتیکال مس مایوژنیکس</h2>\n<ul style="text-align: justify">\n<li>کمک به تامین کربوهیدرات و پروتئین مورد نیاز بدن</li>\n<li>ایده آل برای افزایش وزن و عضلات</li>\n<li>حاوی کراتین، گلوتامین و فیبر</li>\n<li>بدون لاکتوزو چربی ترانس</li>\n<li>تحت لیسانس آمریکا</li>\n</ul>\n<hr>\n<h3 style="text-align: justify">چطور مصرف کنیم</h3>\n<p style="text-align: justify">۱۷۰ گرم از پودر را در ۳۵۰ تا ۴۸۰ میلی لیتر آب مخلوط کنید و چندین بار در روز (بعد از تمرین، بعد از صبحانه و قبل از خواب) مصرف نمایید. برای افزایش کالری می‌توانید این پودر را در کره بادام زمینی، آب میوه، شیر و اوت میل پخته شده اضافه کنید.</p>\n<hr>\n<h3 style="text-align: justify">لطفا دقت کنید</h3>\n<p style="text-align: justify">اگر همزمان از پودر گینر افتر شاک کریتیکال مس مایو جنیکس در کنار داروی خاصی استفاده می‌کنید یا بیماری خاصی دارید، قبل از مصرف با پزشک مشورت کنید.</p>\n<p style="text-align: justify">مکمل افتر شاک جهت تشخیص، درمان و پیشگیری از بیماری‌ها کاربرد ندارد.</p>\n<p style="text-align: justify">در صورت بروز حساسیت، مصرف را قطع و با پزشک مشورت نمایید.</p>\n<p style="text-align: justify">دور از دسترس کودکان و در جای خشک و خنک نگهداری شود.</p>\n<h4 style="text-align: justify">موارد منع مصرف</h4>\n<p style="text-align: justify">پودر گینر افتر شاک کریتیکال مس مایوجنیکس از شیر، سویا، گندم، جو و تخم مرغ گرفته شده است و در صورت حساسیت به هر یک از اجزا، از مصرف این محصول خودداری نمایید.</p>\n<p style="text-align: justify">بیش از حد توصیه شده پودر گینر افتر شاک کریتیکال مس مایو ژنیکس مصرف نکنید.</p>\n<h4 style="text-align: justify">مصرف در دوران بارداری و شیردهی</h4>\n<p style="text-align: justify">در این دوران قبل از مصرف حتما با پزشک مشورت نمایید.</p>\n<h4 style="text-align: justify">عوارض جانبی</h4>\n<p style="text-align: justify">در صورت مصرف به انداره، عارضه خاصی نخواهد داشت.</p>\n<h4 style="text-align: justify">تداخل دارویی</h4>\n<p style="text-align: justify">تاکنون تداخل دارویی خاصی برای این مکمل گزارش نشده است.</p>\n<hr>\n<h4 style="text-align: justify">جدول ترکیبات</h4>\n<table>\n<tbody>\n<tr>\n<td width="159">ترکیبات</td>\n<td width="174">مقدار در هر ۱۷۰ گرم</td>\n<td width="162">درصد نیاز مصرف روزانه</td>\n</tr>\n<tr>\n<td width="159">کالری</td>\n<td width="174">۶۹۰g</td>\n<td width="162">**</td>\n</tr>\n<tr>\n<td width="159">چربی کل</td>\n<td width="174">۱۶g</td>\n<td width="162">۲۵</td>\n</tr>\n<tr>\n<td width="159">چربی اشباع شده</td>\n<td width="174">۳g</td>\n<td width="162">۱۵</td>\n</tr>\n<tr>\n<td width="159">کلسترول</td>\n<td width="174">۴۵mg</td>\n<td width="162">۱۵</td>\n</tr>\n<tr>\n<td width="159">کربوهیدرات</td>\n<td width="174">۸۵g</td>\n<td width="162">۲۸</td>\n</tr>\n<tr>\n<td width="159">فیبر روزانه</td>\n<td width="174">۹g</td>\n<td width="162">۳۶</td>\n</tr>\n<tr>\n<td width="159">فیبر محلول</td>\n<td width="174">۶g</td>\n<td width="162">**</td>\n</tr>\n<tr>\n<td width="159">فیبر غیر محلول</td>\n<td width="174">۳g</td>\n<td width="162">**</td>\n</tr>\n<tr>\n<td width="159">شکر</td>\n<td width="174">۱۵g</td>\n<td width="162">**</td>\n</tr>\n<tr>\n<td width="159">پروتئین</td>\n<td width="174">۵۲g</td>\n<td width="162">**</td>\n</tr>\n</tbody>\n</table>\n<p style="text-align: justify">*نیاز مصرف روزانه از طرف شرکت سازنده مشخص نشده است.</p>\n<p style="text-align: justify">**درصد مصرف روزانه از طرف شرکت سازنده مشخص نشده است.</p>\n<p style="text-align: justify">g = گرم&nbsp; /&nbsp; mg = میلی گرم&nbsp; /&nbsp; µg یا mcg = میکروگرم&nbsp; /&nbsp; IU = واحد بین المللی</p>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t';
    //     let g = toz.replace('\n','');
    //     return g.replace('\t','');
    // }


    useEffect(() => {
        set_data(data)
    }, [])

    useEffect(() => {
        setTimeout(() => {
            getMallDe()
        }, 1000)
    }, [])


    const getMallDe = async () => {
        try {
            // const localMall = localStorage.getItem('mall')
            // if(localMall){
            //     set_mall(JSON.parse(localMall))
            // }
            getMallDetail()
        } catch (e) {
            console.log(e)
        }
    }


    const getMall = async (sub) => {
        try {
            return await getMallWithSubDomain(sub);
        } catch (e) {
            console.log(e)
        }
    }

    const getMallDetail = async () => {
        //detect sub or main link
        let full = window.location.hostname;
        let parts = full.split('.');

        let sub = "";
        let isAdmin = "";

        if (parts.length === 3 && parts[0] !== "www") {
            sub = parts[0]
        } else {
            sub = "app"
        }

        isAdmin = parts[0];

        if (isAdmin === "www" || isAdmin === "test")
            isAdmin = parts[1];

        if (isAdmin === "digimaall" || isAdmin === "test" || isAdmin === "stage" || isAdmin === "localhost" || isAdmin === "apluss" || isAdmin === "app") {
            let temp = isAdmin;
            isAdmin = "digimaall";
            if (temp === "app" && parts[1] !== "apluss") {
                isAdmin = "app"
                console.log("in")
            }
            // if(temp==="app" && parts[1] !== "digimaall"){
            //     isAdmin = "app"
            //     console.log("out")
            // }
        }


        let token = localStorage.getItem("token");

        if (isAdmin !== "digimaall") {
            let malli = await getMall(sub)
            localStorage.setItem('mallId',malli.data.uid);
            localStorage.setItem('mallLogo',malli.data.header_image);
            localStorage.setItem('mall',malli.data.logo);
            localStorage.setItem('mallName',malli.data.name);
            localStorage.setItem('mall',JSON.stringify(malli.data));
            localStorage.setItem('theme',JSON.stringify({
                primary:malli.data.primary_color.color,
                secondary:malli.data.secondary_color.color,
                tertiary:malli.data.tertiary_color.color
            }));
            set_mall(malli.data)
        }
    }

    const gotTo = (page) => {
        history.push("/" + page)
    }

    return (
        <div className="home-fixed-container">
            <div className="home-new-responsive-footer">

                <div className="home-new-responsive-footer-col-about">

                    <div className="home-new-responsive-footer-col-header">
                        <span>درباره داروخانه</span>
                    </div>

                    <div className="home-new-responsive-footer-col-body">
                        <p>
                            {mall && mall.about_us ? mall.about_us : "---"}
                        </p>
                    </div>

                </div>


                <div className="home-new-responsive-footer-col-namad">

                    <div className="home-new-responsive-footer-col-header">
                        <span>نماد اعتماد</span>
                    </div>

                    <div className="home-new-responsive-footer-col-namads">
                        {/*<img src="https://nasleahan.com/wp-content/uploads/2016/03/enamd.jpg" alt=""/>*/}
                        {mall?.enamad_info ? <div dangerouslySetInnerHTML={{__html: `${mall?.enamad_info}`}}/>
                            : null}
                        <img src="https://imenlogo.com/files/services/file_20190726_1738_90551.jpg" alt=""/>
                        <img src="https://ecunion.ir/logonama.png" alt=""/>
                    </div>

                </div>

                <div className="home-new-responsive-footer-col-links">

                    <div className="home-new-responsive-footer-col-header">
                        <span>لینک های مفید</span>
                    </div>

                    <div className="home-new-responsive-footer-col-body">
                        <ul>
                            <li onClick={e => gotTo("terms-guid")}>قوانین و مقررات</li>
                            <li onClick={e => gotTo("shop-guid")}>خرید</li>
                            <li onClick={e => gotTo("shop-guid")}>سفارش</li>
                            <li onClick={e => gotTo("payment-guid")}>پرداخت</li>
                            <li onClick={e => gotTo("returned-guid")}>رویه بازگرداندن کالا</li>
                            <li onClick={e => gotTo("use-guid")}>استفاده</li>
                            <li onClick={e => gotTo("privacy-policy")}>خصوصی</li>

                        </ul>



                    </div>

                </div>





                <div className="home-new-responsive-footer-col-contact">

                    <div className="home-new-responsive-footer-col-header">
                        <span>اطلاعات تماس</span>
                    </div>

                    <div className="home-new-responsive-footer-col-info">
                        <span className="label">تلفن تماس : </span>
                        <span className="phone">{mall?.phone ? mall.phone : "---"}</span>
                    </div>

                    {/*<div className="home-new-responsive-footer-col-info">*/}
                    {/*    <span className="label">ایمیل :</span>*/}
                    {/*    <span >{mall?.email?mall.email:"---"}</span>*/}
                    {/*</div>*/}

                    <br/>
                    <div className="home-new-responsive-footer-col-info">
                        <span className="label">آدرس داروخانه :</span>
                        <p>
                            {mall?.description ? mall.description : "---"}
                        </p>
                    </div>


                    <div className="home-new-responsive-footer-col-body-social">

                        <div className="home-new-responsive-footer-col-body-social-title">
                            <span>ما در شبکه های اجتماعی</span>
                        </div>

                        <div className="home-new-responsive-footer-col-body-social-icons">
                            <img src="https://seeklogo.com/images/T/twitter-icon-square-logo-108D17D373-seeklogo.com.png" alt=""/>
                            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e7/Instagram_logo_2016.svg/2048px-Instagram_logo_2016.svg.png" alt=""/>
                            <img src="https://static-00.iconduck.com/assets.00/telegram-icon-2048x2048-4z30385d.png" alt=""/>
                            <img src="https://upload.wikimedia.org/wikipedia/commons/b/bd/Logo_Aparat.jpg" alt=""/>
                        </div>

                    </div>

                </div>





            </div>


            {/*<div className="home-responsive-footer">*/}

            {/*    <div className="home-responsive-footer-item">*/}
            {/*        <div className="home-responsive-footer-item-title">*/}
            {/*            درباره ما*/}
            {/*        </div>*/}
            {/*        <div className="home-responsive-footer-item-desc">*/}
            {/*            <p>{mall && mall.about_us ? mall.about_us : "---"}</p>*/}
            {/*        </div>*/}
            {/*    </div>*/}

            {/*    <div className="home-responsive-footer-item">*/}
            {/*        <div className="home-responsive-footer-item-title">*/}
            {/*            تماس با ما*/}
            {/*        </div>*/}
            {/*        <div className="home-responsive-footer-item-desc">*/}
            {/*            <p>آدرس: {mall?.description ? mall.description : "---"}</p>*/}
            {/*            <p>تلفن: {mall?.phone ? mall.phone : "---"}</p>*/}
            {/*            <p>ایمیل: {mall?.email?mall.email:"---"}</p>*/}
            {/*        </div>*/}
            {/*    </div>*/}


                {/*<div className="home-responsive-footer-item">*/}
                {/*    <div className="home-responsive-footer-item-title">*/}
                {/*        لینک ها*/}
                {/*    </div>*/}
                {/*    <div className="home-responsive-footer-item-desc">*/}
                {/*        <p onClick={e => gotTo("terms-guid")} className="home-responsive-footer-item-link">*/}
                {/*            قوانین و مقررات</p>*/}
                {/*        <p onClick={e => gotTo("shop-guid")} className="home-responsive-footer-item-link">راهنمای*/}
                {/*            خرید</p>*/}
                {/*        <p onClick={e => gotTo("send-guid")} className="home-responsive-footer-item-link">رویه ارسال*/}
                {/*            سفارش</p>*/}
                {/*        <p onClick={e => gotTo("payment-guid")} className="home-responsive-footer-item-link">شیوه های*/}
                {/*            پرداخت</p>*/}
                {/*        <p onClick={e => gotTo("returned-guid")} className="home-responsive-footer-item-link">رویه*/}
                {/*            بازگرداندن کالا</p>*/}
                {/*        <p onClick={e => gotTo("use-guid")} className="home-responsive-footer-item-link">شرایط*/}
                {/*            استفاده</p>*/}
                {/*        <p onClick={e => gotTo("privacy-policy")} className="home-responsive-footer-item-link">حریم*/}
                {/*            خصوصی</p>*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/*<div className="home-responsive-footer-item-logo">*/}
                {/*    <img*/}
                {/*        src="https://themde56.mywebzi.ir/uploads/3bdaf83a37b4476292ed2e886dbdd885.w_91,h_105,r_k.png.webp"*/}
                {/*        alt=""/>*/}


                {/*    /!*{mall?.uid==="QWuC797g4b"?<a referrerPolicy="origin" target="_blank"*!/*/}
                {/*    /!*                  href="https://trustseal.enamad.ir/?id=330689&amp;Code=983QvMNVH6iRYilm5t02"><img*!/*/}
                {/*    /!*    referrerPolicy="origin"*!/*/}
                {/*    /!*    src="https://Trustseal.eNamad.ir/logo.aspx?id=330689&amp;Code=983QvMNVH6iRYilm5t02" alt=""*!/*/}
                {/*    /!*    style={{cursor:"pointer"}} id="983QvMNVH6iRYilm5t02"/></a>:null}*!/*/}

                {/*    {mall?.enamad_info ? <div dangerouslySetInnerHTML={{__html: `${mall?.enamad_info}`}}/>*/}
                {/*        : null}*/}

                {/*</div>*/}

            {/*</div>*/}
            {/*<div style={{direction:"rtl",fontFamily:"YekanRegular"}} dangerouslySetInnerHTML={{ __html: convertDescHtml() }} />*/}
        </div>

    )
}

export default FooterDesktop;

